//Homepage

/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
/* eslint-disable */
(function trackingHomepage() {
    function gtagTracking(event_category, event_action, event_label) {
        window.gtag('event', 'Convert_Test_Tracking', {
            method: 'Convert',
            event_category,
            event_action,
            event_label
        });
    }

    function waitUntil(predicate, success, error) {
        let int = setInterval(() => {
            if (predicate()) {
                clearInterval(int);
                int = null;
                success();
            }
        }, 33);
        setTimeout(() => {
            if (int !== null) {
                clearInterval(int);
                if (typeof error === 'function') {
                    error();
                }
            }
        }, 25000);
    }

    function delegateEvent(el, evt, sel, handler) {
        el.addEventListener(evt, function (event) {
            let t = event.target;
            while (t && t !== this) {
                if (t.matches(sel)) {
                    event.matchedSelector = t;
                    handler.call(t, event);
                    break;
                }
                t = t.parentNode;
            }
        });
    }

    function convertGoal(id) {
        console.log(id);
        // window._conv_q = window._conv_q || [];
        // _conv_q.push(['triggerConversion', id]);
    }

    const URL = window.location.pathname;
    const isMenURL = URL === '/';
    const isWomenURL = URL === '/';

    setTimeout(() => {
        waitUntil(() => typeof window.gtag === 'function', () => {
            // delegateEvent(document, 'mousedown', '.toggle-menu-container', (e) => {
            //     const clickedEl = e.target;
            //     const subCategoryItem = clickedEl.closest('.menu-item');
            //     const viewAllBtn = clickedEl.closest('#viewAllLink');
            //     const container = clickedEl.closest('.toggle-menu-container');
            //     const categoryName = container && container.querySelector('.toggle-button.active') && container.querySelector('.toggle-button.active').getAttribute('data-category').toLowerCase().trim();

            //     const getProductName = ((el) => el && el.querySelector('p') && el.querySelector('p').textContent) || '';

            //     if (subCategoryItem) {
            //         if (isWomenURL) {
            //             if (categoryName === 'bestsellers') {
            //                 convertGoal('100244459');
            //                 gtagTracking('SD_HP_Event', 'Homepage Women - Interaction with Bestsellers', getProductName(subCategoryItem));
            //             } else if (categoryName === 'new') {
            //                 convertGoal('100244460');
            //                 gtagTracking('SD_HP_Event', 'Homepage Women - Interaction with New Arrival', getProductName(subCategoryItem));
            //             } else if (categoryName === 'bottoms') {
            //                 convertGoal('100244461');
            //                 gtagTracking('SD_HP_Event', 'Homepage Women - Interaction with Bottom wear', getProductName(subCategoryItem));
            //             } else if (categoryName === 'tops') {
            //                 convertGoal('100244462');
            //                 gtagTracking('SD_HP_Event', 'Homepage Women - Interaction with Top Wear', getProductName(subCategoryItem));
            //             }
            //         } else if (isMenURL) {
            //             if (categoryName === 'bestsellers') {
            //                 convertGoal('100244463');
            //                 gtagTracking('SD_HP_Event', 'Homepage Men - Interaction with Bestsellers', getProductName(subCategoryItem));
            //             } else if (categoryName === 'newarrival') {
            //                 convertGoal('100244464');
            //                 gtagTracking('SD_HP_Event', 'Homepage Men - Interaction with New Arrival', getProductName(subCategoryItem));
            //             } else if (categoryName === 'shortkurta') {
            //                 convertGoal('100244465');
            //                 gtagTracking('SD_HP_Event', 'Homepage Men - Interaction with Airy Linen Short Kurta', getProductName(subCategoryItem));
            //             } else if (categoryName === 'longkurta') {
            //                 convertGoal('100244466');
            //                 gtagTracking('SD_HP_Event', 'Homepage Men - Interaction with Airy Linen Long Kurta', getProductName(subCategoryItem));
            //             } else if (categoryName === 'formalshirt') {
            //                 convertGoal('100244467');
            //                 gtagTracking('SD_HP_Event', 'Homepage Men - Interaction with Formal Shirt', getProductName(subCategoryItem));
            //             }
            //         }
            //     } else if (viewAllBtn) {
            //         if (isWomenURL) {
            //             if (categoryName === 'bestsellers') {
            //                 convertGoal('100244468');
            //                 gtagTracking('SD_HP_Event', 'Homepage Women - Interaction with View All in Bestsellers', 'Interaction');
            //             } else if (categoryName === 'new') {
            //                 convertGoal('100244469');
            //                 gtagTracking('SD_HP_Event', 'Homepage Women - Interaction with View All in New Arrival', 'Interaction');
            //             } else if (categoryName === 'bottoms') {
            //                 convertGoal('100244470');
            //                 gtagTracking('SD_HP_Event', 'Homepage Women - Interaction with View All in Bottom wear', 'Interaction');
            //             } else if (categoryName === 'tops') {
            //                 convertGoal('100244471');
            //                 gtagTracking('SD_HP_Event', 'Homepage Women - Interaction with View All in Top Wear', 'Interaction');
            //             }
            //         } else if (isMenURL) {
            //             if (categoryName === 'bestsellers') {
            //                 convertGoal('100244472');
            //                 gtagTracking('SD_HP_Event', 'Homepage Men - Interaction with View All in Bestsellers', 'Interaction');
            //             } else if (categoryName === 'newarrival') {
            //                 convertGoal('100244473');
            //                 gtagTracking('SD_HP_Event', 'Homepage Men - Interaction with View All in New Arrival', 'Interaction');
            //             } else if (categoryName === 'shortkurta') {
            //                 convertGoal('100244474');
            //                 gtagTracking('SD_HP_Event', 'Homepage Men - Interaction with View All in Airy Linen Short Kurta', 'Interaction');
            //             } else if (categoryName === 'longkurta') {
            //                 convertGoal('100244475');
            //                 gtagTracking('SD_HP_Event', 'Homepage Men - Interaction with View All in Airy Linen Long Kurta', 'Interaction');
            //             } else if (categoryName === 'formalshirt') {
            //                 convertGoal('100244476');
            //                 gtagTracking('SD_HP_Event', 'Homepage Men - Interaction with View All in Formal Shirt', 'Interaction');
            //             }
            //         }
            //     }
            // });

            // Homepage- Interaction with View More in Socially Approved //

            document.body.addEventListener('click', ({ target }) => {
                // Homepage- Interaction with Women/Men //
                const genderToggle = target.closest('.gender-floating-container #btn-women, .gender-floating-container #btn-men');
                if (genderToggle) {
                    convertGoal('100244416');
                    gtagTracking('SD_HP_Event', 'Homepage- Interaction with Women/Men', genderToggle.textContent.trim() || 'Unknown');
                }

                if (target.closest('.banner-smart-wrapper.show-women:nth-child(3)')) {
                    convertGoal('100244418');
                    gtagTracking('SD_HP_Event', 'Homepage Women - Interaction with CTA in Banner 1', 'Interaction');
                }

                if (target.closest('.banner-smart-wrapper.show-women:nth-child(4)')) {
                    convertGoal('100244419');
                    gtagTracking('SD_HP_Event', 'Homepage Women - Interaction with CTA in Banner 2', 'Interaction');
                }

                if (target.closest('.banner-smart-wrapper.show-men:nth-child(1)')) {
                    convertGoal('100244509');
                    gtagTracking('SD_HP_Event', 'Homepage Men - Interaction with CTA in Banner 1', 'Interaction');
                }

                if (target.closest('.banner-smart-wrapper.show-men:nth-child(2)')) {
                    convertGoal('100244510');
                    gtagTracking('SD_HP_Event', 'Homepage Men - Interaction with CTA in Banner 2', 'Interaction');
                }

                const menuItem = target.closest('.toggle-menu-container .menu-items-container .menu-item a');
                if (menuItem) {
                    const activeCategory = menuItem.closest('.toggle-menu-container').querySelector('.toggle-menu-container .toggle-buttons-wrapper .toggle-button.active');
                    if (activeCategory) {
                        const activeCategoryText = (activeCategory.dataset.title || activeCategory.textContent || '').trim().toLowerCase();
                        const isWomenCat = activeCategory.classList.contains('show-women') || /\bwomen\b/.test(activeCategoryText);
                        const isMenCat = activeCategory.classList.contains('show-men') || (/\bmen\b/.test(activeCategoryText) && !/\bwomen\b/.test(activeCategoryText));
                        const label = menuItem.textContent.trim() || 'Unknown';

                        if (isWomenCat) {
                            if (activeCategoryText.includes('best seller')) {
                                convertGoal('100244459');
                                gtagTracking('SD_HP_Event', 'Homepage Women - Interaction with Bestsellers', label);
                            } else if (activeCategoryText.includes('new arrival')) {
                                convertGoal('100244460');
                                gtagTracking('SD_HP_Event', 'Homepage Women - Interaction with New Arrival', label);
                            } else if (activeCategoryText.includes('bottom')) {
                                convertGoal('100244461');
                                gtagTracking('SD_HP_Event', 'Homepage Women - Interaction with Bottom Wear', label);
                            } else if (activeCategoryText.includes('top')) {
                                convertGoal('100244462');
                                gtagTracking('SD_HP_Event', 'Homepage Women - Interaction with Top Wear', label);
                            }
                        }

                        if (isMenCat) {
                            if (activeCategoryText.includes('best seller')) {
                                convertGoal('100244463');
                                gtagTracking('SD_HP_Event', 'Homepage Men - Interaction with Bestsellers', label);
                            } else if (activeCategoryText.includes('new arrival')) {
                                convertGoal('100244464');
                                gtagTracking('SD_HP_Event', 'Homepage Men - Interaction with New Arrival', label);
                            } else if (activeCategoryText.includes('bottom')) {
                                convertGoal('');
                                gtagTracking('SD_HP_Event', 'Homepage Men - Interaction with Bottom Wear', label);
                            } else if (activeCategoryText.includes('top')) {
                                convertGoal('');
                                gtagTracking('SD_HP_Event', 'Homepage Men - Interaction with Top Wear', label);
                            }
                        }
                    }
                }

                const viewAllLink = target.closest('.toggle-menu-container .view-all-bar .view-all-btn, .toggle-menu-container .view-all-btn');
                if (viewAllLink) {
                    const activeCategory = viewAllLink.closest('.toggle-menu-container').querySelector('.toggle-menu-container .toggle-buttons-wrapper .toggle-button.active');

                    if (activeCategory) {
                        const activeCategoryText = (activeCategory.dataset.title || activeCategory.textContent || '').trim().toLowerCase();
                        const isWomenCat = activeCategory.classList.contains('show-women') || /\bwomen\b/.test(activeCategoryText);
                        const isMenCat = activeCategory.classList.contains('show-men') || (/\bmen\b/.test(activeCategoryText) && !/\bwomen\b/.test(activeCategoryText));

                        if (isWomenCat) {
                            if (activeCategoryText.includes('best seller')) {
                                convertGoal('100244468');
                                gtagTracking('SD_HP_Event', 'Homepage Women - Interaction with View All in Bestsellers', 'Interaction');
                            } else if (activeCategoryText.includes('new arrival')) {
                                convertGoal('100244469');
                                gtagTracking('SD_HP_Event', 'Homepage Women - Interaction with View All in New Arrival', 'Interaction');
                            } else if (activeCategoryText.includes('bottom')) {
                                convertGoal('100244470');
                                gtagTracking('SD_HP_Event', 'Homepage Women - Interaction with View All in Bottom Wear', 'Interaction');
                            } else if (activeCategoryText.includes('top')) {
                                convertGoal('100244471');
                                gtagTracking('SD_HP_Event', 'Homepage Women - Interaction with View All in Top Wear', 'Interaction');
                            }
                        }

                        if (isMenCat) {
                            if (activeCategoryText.includes('best seller')) {
                                convertGoal('100244472');
                                gtagTracking('SD_HP_Event', 'Homepage Men - Interaction with View All in Bestsellers', 'Interaction');
                            } else if (activeCategoryText.includes('new arrival')) {
                                convertGoal('100244473');
                                gtagTracking('SD_HP_Event', 'Homepage Men - Interaction with View All in New Arrival', 'Interaction');
                            } else if (activeCategoryText.includes('bottom')) {
                                convertGoal('');
                                gtagTracking('SD_HP_Event', 'Homepage Men - Interaction with View All in Bottom Wear', 'Interaction');
                            } else if (activeCategoryText.includes('top')) {
                                convertGoal('');
                                gtagTracking('SD_HP_Event', 'Homepage Men - Interaction with View All in Top Wear', 'Interaction');
                            }
                        }
                    }
                }
            });

            delegateEvent(document, 'mousedown', '.whatmore-carousel-events .wht-tf-view-cta > div', () => {
                convertGoal('100244421');
                if (isWomenURL) {
                    gtagTracking('SD_HP_Event', 'Homepage Women- Interaction with View More in Socially Approved', 'Interaction');
                } else if (isMenURL) {
                    gtagTracking('SD_HP_Event', 'Homepage Men- Interaction with View More in Socially Approved', 'Interaction');
                }
            });

            // Homepage- Interaction with Get to Know Us Better //

            delegateEvent(document, 'mousedown', '.product-gallery__carousel .product_image[href*="/pages/"], .product-gallery__carousel a.product_image[href*="/pages/"]', function () {
                const tileName = (this.querySelector('button') && this.querySelector('button').textContent.trim())
                    || this.getAttribute('aria-label')
                    || 'Interaction';
                convertGoal('100244437');
                if (isWomenURL) {
                    gtagTracking('SD_HP_Event', 'Homepage - Interaction with Get to Know Us Better', tileName);
                } else if (isMenURL) {
                    gtagTracking('SD_HP_Event', 'Homepage - Interaction with Get to Know Us Better', tileName);
                }
            });

            // Homepage- Scroll Reviews //
            waitUntil(() => document.querySelectorAll('.shopify-block > .loox-v2-carousel-container, .loox-v2-carousel-container, [class*="loox"][class*="carousel"]').length > 0, () => {
                const target = document.querySelector('.shopify-block > .loox-v2-carousel-container, .loox-v2-carousel-container, [class*="loox"][class*="carousel"]');

                const observer = new IntersectionObserver(((entries) => {
                    if (entries[0].isIntersecting) {
                        convertGoal('100244436');

                        if (isWomenURL) {
                            gtagTracking('SD_HP_Event', 'Homepage Women- Scroll Reviews', 'Scroll');
                        } else if (isMenURL) {
                            gtagTracking('SD_HP_Event', 'Homepage Men- Scroll Reviews', 'Scroll');
                        }
                        observer.unobserve(target);
                    }
                }), { threshold: [1] });

                if (target) {
                    observer.observe(target);
                }
            });

            // Homepage- Interaction with Journal //
            delegateEvent(document, 'mousedown', '.logo-list-container scroll-carousel > a.product_image[href*="/blogs/"], .product-gallery__carousel a.product_image[href*="/blogs/"], a.product_image[href*="/blogs/"]', () => {
                convertGoal('100244435');
                if (isWomenURL) {
                    gtagTracking('SD_HP_Event', 'Homepage - Interaction with Journal', 'Read More Clicked');
                } else if (isMenURL) {
                    gtagTracking('SD_HP_Event', 'Homepage - Interaction with Journal', 'Read More Clicked');
                }
            });
        });
    }, 2000);
}());


//PLP + PDP + Cart

/* eslint-disable func-names */
/* eslint-disable max-len */
/* eslint-disable*/
(function trackingPLPPDPCart() {
    function gtagTracking(event_category, event_action, event_label) {
        window.gtag('event', 'Convert_Test_Tracking', {
            method: 'Convert',
            event_category,
            event_action,
            event_label
        });
    }

    function waitUntil(predicate, success, error) {
        let int = setInterval(() => {
            if (predicate()) {
                clearInterval(int);
                int = null;
                success();
            }
        }, 50);
        setTimeout(() => {
            if (int !== null) {
                clearInterval(int);
                if (typeof error === 'function') {
                    error();
                }
            }
        }, 20000);
    }

    function debounce(fn, delay) {
        let timeoutId;
        return function (...args) {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => fn.apply(this, args), delay);
        };
    }

    function delegateEvent(el, evt, sel, handler) {
        el.addEventListener(evt, function (event) {
            let t = event.target;
            while (t && t !== this) {
                if (t.matches(sel)) {
                    event.matchedSelector = t;
                    handler.call(t, event);
                    break;
                }
                t = t.parentNode;
            }
        });
    }

    function getImageInViewIndex(images, slider) {
        const sliderRect = slider.getBoundingClientRect();
        let closestImageIndex = -1;
        let closestDistance = Infinity;
        const threshold = 0.5;

        images.forEach((image, index) => {
            const imageRect = image.getBoundingClientRect();
            if (!imageRect.width) return;
            const imageVisibleRatio = Math.min(imageRect.right, window.innerWidth) - Math.max(imageRect.left, 0);

            if (imageVisibleRatio / imageRect.width > threshold) {
                const distance = Math.abs(imageRect.left - sliderRect.left);
                if (distance < closestDistance) {
                    closestDistance = distance;
                    closestImageIndex = index;
                }
            }
        });

        return closestImageIndex;
    }

    function convertGoal(id) {
        console.log(id);
        // window._conv_q = window._conv_q || [];
        // _conv_q.push(['triggerConversion', id]);
    }

    setTimeout(() => {
        waitUntil(() => typeof window.gtag === 'function', () => {
            const { location: { pathname } } = window;
            // PLP
            if (pathname.includes('/collections/')) {
                // PLP- Open Filter Menu
                delegateEvent(document, 'mousedown', 'button[aria-controls="facets-drawer"], .ncp-fb-filter, [data-fb-filter], .saw-ff-filterbtn, [data-saw-open-filter], .fixed-nav-item a[href*="return_prime"], .fixed_nav--link[data-nav="community"]', () => {
                    convertGoal('100244725');
                    gtagTracking('SD_PLP_Event', 'PLP- Open Filter Menu', 'Open');
                });

                // PLP- Filter Interaction
                delegateEvent(document, 'mousedown', 'details.accordion, .saw-size-circ, .saw-fam, .saw-fgroup-btn, .ncp-disc-tab, .ncp-disc-sechead, .ncp-disc-card, .ncp-fs-size, .ncp-fs-color', (e) => {
                    const accordion = e.target.closest('details.accordion');
                    if (accordion && e.target.closest('.accordion__toggle')) {
                        const labelEl = accordion.querySelector('summary span[class*="text"]');
                        if (labelEl) {
                            const label = labelEl.textContent.trim();
                            convertGoal('100244493');
                            gtagTracking('SD_PLP_Event', 'PLP- Filter Interaction', label);
                        }
                        return;
                    }

                    const filterItem = e.target.closest('.saw-size-circ, .saw-fam, .saw-fgroup-btn, .ncp-disc-tab, .ncp-disc-sechead, .ncp-disc-card, .ncp-fs-size, .ncp-fs-color');
                    if (filterItem) {
                        const label = filterItem.textContent.trim();
                        if (label) {
                            convertGoal('100244493');
                            gtagTracking('SD_PLP_Event', 'PLP- Filter Interaction', label);
                        }
                    }
                });

                // Close Filter Menu
                delegateEvent(document, 'mousedown', '.facets-drawer, .saw-close[data-saw-close-filter], .ncp-disc-close, .ncp-fs-close, .saw-overlay.is-visible', ({ target }) => {
                    if (target.id === 'facets-drawer') {
                        const header = target.querySelector('p.h4[slot="header"]');
                        if (header) {
                            const text = header.textContent.trim().toLowerCase();
                            if (text.includes('filter')) {
                                convertGoal('100244494');
                                gtagTracking('SD_PLP_Event', 'Close Filter Menu', 'Close');
                            }
                        }
                        return;
                    }

                    if (target.closest('.saw-close[data-saw-close-filter], .ncp-disc-close, .ncp-fs-close')) {
                        convertGoal('100244494');
                        gtagTracking('SD_PLP_Event', 'Close Filter Menu', 'Close');
                        return;
                    }

                    if (target.classList.contains('saw-overlay') && target.classList.contains('is-visible')) {
                        convertGoal('100244494');
                        gtagTracking('SD_PLP_Event', 'Close Filter Menu', 'Close');
                    }
                });

                // PLP- Sort By Interaction
                delegateEvent(document, 'mousedown', 'facets-sort-popover[open] x-listbox button', (e) => {
                    const name = e.target.textContent.trim();
                    convertGoal('100244495');
                    gtagTracking('SD_PLP_Event', 'PLP- Sort By Interaction', name);
                });

                // PLP- Layout & View Interaction
                delegateEvent(document, 'mousedown', 'collection-layout-switch[device="mobile"] button, collection-layout-switch[device="desktop"] button', (e) => {
                    setTimeout(() => {
                        const button = e.target.closest('button');
                        let label = '';
                        if (button.classList.contains('is-active') && button.getAttribute('value') === 'large') {
                            label = 'First';
                        } else if (button.classList.contains('is-active') && button.getAttribute('value') === 'medium') {
                            label = 'Second';
                        }
                        convertGoal('100244496');
                        gtagTracking('SD_PLP_Event', 'PLP- Layout & View Interaction', label);
                    }, 500);
                });

                // PLP- Product Card Interaction
                delegateEvent(document, 'mousedown', '.collection__main .product-list .product-card, .saw-cat[data-zone="coll"] .p-card, .saw-grid .p-card', (e) => {
                    const card = e.target.closest('.product-card, .p-card');
                    if (card) {
                        const title = card.querySelector('.product-title, .p-ttl');
                        const productName = (title && title.textContent.trim()) || card.dataset.handle || '';
                        if (productName) {
                            convertGoal('100245476');
                            gtagTracking('SD_PLP_Event', 'PLP- Product Card Interaction', productName);
                        }
                    }
                });

                // PLP- Recently Viewed Section Scroll
                waitUntil(() => document.querySelector('scroll-carousel[id*="recently-viewed"], scroll-carousel.product-list, .saw-cat[data-zone="fbt"] .saw-track, .saw-cat[data-zone="ml"] .saw-track'), () => {
                    document.querySelectorAll('scroll-carousel[id*="recently-viewed"], scroll-carousel.product-list, .saw-cat[data-zone="fbt"] .saw-track, .saw-cat[data-zone="ml"] .saw-track').forEach((scrollable) => {
                        scrollable.addEventListener('scroll', debounce(() => {
                            convertGoal('100245477');
                            gtagTracking('SD_PLP_Event', 'PLP- Recently Viewed Section Scroll', 'Swipe');
                        }, 900));
                    });
                });

                // PLP- Recently Viewed Product Interaction
                delegateEvent(document, 'mousedown', 'scroll-carousel[id*="recently-viewed"] a', function (e) {
                    if (this.matches('scroll-carousel[id*="recently-viewed"] a') || this.closest('scroll-carousel[id*="recently-viewed"]')) {
                        const link = this.closest('a') || this;
                        const titleEl = link.querySelector('.prc-ttl');
                        const productName = (titleEl && titleEl.textContent.trim())
                            || link.getAttribute('aria-label')
                            || link.textContent.trim();
                        if (productName) {
                            convertGoal('100245478');
                            gtagTracking('SD_PLP_Event', 'PLP- Recently Viewed Product Interaction', productName);
                        }
                        return;
                    }

                    const productCard = e.target.closest('product-card');
                    const pCard = e.target.closest('.p-card');
                    const productName = (productCard && productCard.getAttribute('handle'))
                        || (pCard && (pCard.querySelector('.p-ttl') ? pCard.querySelector('.p-ttl').textContent.trim() : pCard.dataset.handle))
                        || '';
                    if (productName) {
                        convertGoal('100245478');
                        gtagTracking('SD_PLP_Event', 'PLP- Recently Viewed Product Interaction', productName);
                    }
                });

                // Sub-Category Filters Available
                const targetURLs = ['/collections/shop-all-tops-1', '/collections/shop-all-bottoms', '/collections/shop-airy-linen', '/collections/all-whites', '/collections/best-sellers-women', '/collections/men-shop-all-bottoms'];
                if (targetURLs.some((url) => pathname.includes(url))) {
                    convertGoal('100244854');
                    gtagTracking('SD_PLP_Event', 'Sub-Category Filters Available', pathname);
                }

                // PLP- Interaction with Sub-Category Filters
                delegateEvent(document, 'mousedown', '.facets[is="facets-form"] .c_nav_filter .facets-scroll-inner .checkbox-control, .saw-roundel', (e) => {
                    const checkbox = e.target.closest('.checkbox-control');
                    if (checkbox) {
                        const labelEl = checkbox.querySelector('label');
                        if (labelEl) {
                            const label = labelEl.textContent.trim();
                            convertGoal('100244855');
                            gtagTracking('SD_PLP_Event', 'PLP- Interaction with Sub-Category Filters', label);
                        }
                        return;
                    }

                    const roundel = e.target.closest('.saw-roundel');
                    if (roundel) {
                        const label = roundel.querySelector('.saw-roundel-label') ? roundel.querySelector('.saw-roundel-label').textContent.trim() : roundel.textContent.trim();
                        if (label) {
                            convertGoal('100244855');
                            gtagTracking('SD_PLP_Event', 'PLP- Interaction with Sub-Category Filters', label);
                        }
                    }
                });
            }

            // PDP
            if (pathname.includes('/products/')) {
                // PDP- Images Interaction
                waitUntil(() => document.querySelector('.swiffy-slider .slider-container, product-gallery .product-gallery__carousel, .product-gallery__carousel'), () => {
                    const sliders = Array.from(document.querySelectorAll('.swiffy-slider .slider-container, product-gallery .product-gallery__carousel, .product-gallery__carousel'))
                        .filter((slider) => slider.getBoundingClientRect().width > 0 || slider.scrollWidth > slider.clientWidth);

                    // Prefer the visible mobile swiffy slider when present
                    const targets = sliders.length
                        ? sliders
                        : Array.from(document.querySelectorAll('.swiffy-slider .slider-container'));

                    targets.forEach((slider) => {
                        const images = Array.from(slider.querySelectorAll('.product_image, .product-gallery__media'))
                            .filter((img) => img.getBoundingClientRect().width > 0 || img.offsetWidth > 0 || img.classList.contains('product_image'));

                        if (slider && images.length > 0) {
                            slider.addEventListener('scroll', debounce(() => {
                                const imageInViewIndex = getImageInViewIndex(images, slider);
                                if (imageInViewIndex !== -1) {
                                    convertGoal('100244679');
                                    gtagTracking('SD_PDP_Event', 'PDP- Images Interaction', `image_${imageInViewIndex + 1}`);
                                }
                            }, 900));
                        }
                    });
                });

                delegateEvent(document, 'mousedown', '#product', (e) => {
                    // PDP- Zoom Image Interaction
                    if (e.target.closest('.product-gallery__image-list, button.product_zoom, button.product-gallery__zoom-button, [is="open-lightbox-button"]')) {
                        convertGoal('100244680');
                        gtagTracking('SD_PDP_Event', 'PDP- Zoom Image Interaction', 'Interaction');
                    }
                    // PDP- Share Interaction
                    if (e.target.closest('.share_button_wrapper button.share-buttons')) {
                        convertGoal('100244681');
                        gtagTracking('SD_PDP_Event', 'PDP- Share Interaction', 'Interaction');
                    }
                    // PDP- View Similar Interaction
                    if (e.target.closest('.product_media .view_similar_button')) {
                        convertGoal('100244682');
                        gtagTracking('SD_PDP_Event', 'PDP- View Similar Interaction', 'Interaction');
                    }
                    // PDP- Reviews Star Interaction
                    if (e.target.closest('a.looxReview, span.looxReview a, a.rating-badge, .looxReview a[href*="looxReviews"]')) {
                        convertGoal('100244685');
                        gtagTracking('SD_PDP_Event', 'PDP- Reviews Star Interaction', 'Interaction');
                    }

                    // PDP- Colour Interaction
                    if (e.target.closest('.variant-picker__option-values .color-swatch')) {
                        convertGoal('100244687');
                        gtagTracking('SD_PDP_Event', 'PDP- Colour Interaction', e.target.closest('.variant-picker__option-values .color-swatch').textContent.trim());
                    }

                    // PDP- Waist Size Interaction
                    const variantButtons = e.target.closest('.inline-size-atc__row .variant-container button.variant-btn, .saadaa-variant-container .saadaa-variant-btn');
                    if (variantButtons) {
                        convertGoal('100244688');
                        gtagTracking('SD_PDP_Event', 'PDP- Waist Size Interaction', variantButtons.dataset.value);
                    }

                    // PDP- Size Chart Interaction
                    if (e.target.closest('#KiwiSizingChart button.ks-chart-modal-button, .ks-open-btn, .saadaa-ks-open-btn')) {
                        convertGoal('100244689');
                        gtagTracking('SD_PDP_Event', 'PDP- Size Chart Interaction', 'Interaction');
                    }

                    // // PDP- Select A Size/ ATC Interaction
                    // if (e.target.closest('.size_popup_button')) {
                    //     const button = e.target.closest('.size_popup_button');
                    //     const container = button.closest('.product-info__block-list');
                    //     if (container) {
                    //         const titleEl = container.querySelector('.product-info__block-item .product-title');
                    //         if (titleEl) {
                    //             const productName = titleEl.textContent.trim();
                    //             convertGoal('100245065');
                    //             gtagTracking(
                    //                 'SD_PDP_Event',
                    //                 'PDP- Select A Size Interaction',
                    //                 productName
                    //             );
                    //         }
                    //     }
                    // }

                    const addToBagCTA = e.target.closest('.scb-main-btn');
                    if (addToBagCTA) {
                        const container = addToBagCTA.closest('.product-info__block-list');
                        if (container) {
                            const titleEl = container.querySelector('.product-info__block-item .product-title');
                            if (titleEl) {
                                const productName = titleEl.textContent.trim();
                                convertGoal('100245063');
                                convertGoal('100244506');
                                gtagTracking(
                                    'SD_PDP_Event',
                                    'PDP- ATC Interaction',
                                    productName
                                );
                            }
                        }
                    }

                    // PDP- Accordions Interaction
                    if (e.target.closest('.product-info__block-item .accodion_wrapper .new_accordion:not(.acc_active)')) {
                        convertGoal('100244692');
                        gtagTracking('SD_PDP_Event', 'PDP- Accordions Interaction', e.target.closest('.product-info__block-item .accodion_wrapper .new_accordion').querySelector('.acc_button_text').textContent.trim());
                    }
                });

                delegateEvent(document, 'mousedown', 'body', (e) => {
                    // PDP- Breadcrumbs Interaction
                    if (e.target.closest('#breadcrumbs span:nth-child(1) a, #breadcrumbs1 span:nth-child(1) a')) {
                        convertGoal('100244686');
                        gtagTracking('SD_PDP_Event', 'PDP- Breadcrumbs Interaction', 'First');
                    }
                    if (e.target.closest('#breadcrumbs span:nth-child(2) a, #breadcrumbs1 span:nth-child(2) a')) {
                        convertGoal('100244686');
                        gtagTracking('SD_PDP_Event', 'PDP- Breadcrumbs Interaction', 'Second');
                    }
                    if (e.target.closest('#breadcrumbs span:nth-child(3) a, #breadcrumbs1 span:nth-child(3) a')) {
                        convertGoal('100244686');
                        gtagTracking('SD_PDP_Event', 'PDP- Breadcrumbs Interaction', 'Third');
                    }
                });

                // PDP- Pair It With Interaction
                delegateEvent(document, 'mousedown', '#pair-it-with1 product-card a.product-card, #pair-it-with1 a.prc-card', (e) => {
                    const card = e.target.closest('product-card');
                    const prcCard = e.target.closest('a.prc-card');
                    if (card) {
                        const titleEl = card.querySelector('.product-title');
                        if (titleEl) {
                            const productName = titleEl.textContent.trim();
                            convertGoal('100244694');
                            gtagTracking('SD_PDP_Event', 'PDP- Pair It With Interaction', productName);
                        }
                    } else if (prcCard) {
                        const productName = prcCard.getAttribute('aria-label')
                            || prcCard.querySelector('.prc-ttl') ? prcCard.querySelector('.prc-ttl').textContent.trim() : ''
                            || prcCard.textContent.trim();
                        if (productName) {
                            convertGoal('100244694');
                            gtagTracking('SD_PDP_Event', 'PDP- Pair It With Interaction', productName);
                        }
                    }
                });

                delegateEvent(document, 'mousedown', '.view_similar.popup', (e) => {
                    // Similar Style in View Similar
                    const link = e.target.closest('featured-collections-carousel a');
                    if (link) {
                        convertGoal('100244683');
                        gtagTracking('SD_PDP_Event', 'Similar Style in View Similar', link.querySelector('.prc-ttl').textContent.trim());
                    }
                    // Pair it with in View Similar
                    const pairItWithLink = e.target.closest('carousel-navigation button:nth-child(2)');
                    if (pairItWithLink) {
                        convertGoal('100244684');
                        gtagTracking('SD_PDP_Event', 'Pair it with in View Similar', 'Interaction');
                    }
                });

                // // PDP-  Select A Size/ ATC Sticky CTA Interaction
                // delegateEvent(document, 'mousedown', '#sticky-cart-bar .scb-main-btn:not(.ready)', function () {
                //     const section = this.closest('section');
                //     if (section) {
                //         const titleEl = section.querySelector('#product .product-title');
                //         if (titleEl) {
                //             const productName = titleEl.textContent.trim();
                //             convertGoal('100245066');
                //             gtagTracking('SD_PDP_Event', 'PDP- Select A Size Sticky CTA Interaction', productName);
                //         }
                //     }
                // });

                delegateEvent(document, 'mousedown', '#saadaa-sticky-cart-bar .saadaa-scb-main-btn', function () {
                    const section = this.closest('section');
                    if (section) {
                        const titleEl = section.querySelector('#product .product-title');
                        if (titleEl) {
                            const productName = titleEl.textContent.trim();
                            convertGoal('100245064');
                            gtagTracking('SD_PDP_Event', 'PDP- ATC Sticky CTA Interaction', productName);
                        }
                    }
                });

                // PDP- Why You'll Love This Interaction
                waitUntil(() => document.querySelector('.wysb_container scroll-carousel'), () => {
                    const scrollable = document.querySelector('.wysb_container scroll-carousel');
                    if (scrollable) {
                        scrollable.addEventListener('scroll', debounce(() => {
                            convertGoal('100244693');
                            gtagTracking('SD_PDP_Event', "PDP- Why You'll Love This Interaction", 'Scroll');
                        }, 900));
                    }
                });

                // PDP- FAQs Interaction
                delegateEvent(document, 'mousedown', 'main#main .faq .faq__content .accordion .accordion__toggle', function () {
                    convertGoal('100244695');
                    gtagTracking('SD_PDP_Event', 'PDP- FAQs Interaction', this.textContent.trim());
                });

                // PDP- Recently Viewed Interaction
                delegateEvent(document, 'mousedown', 'recently-viewed-products product-card a, recently-viewed-products a.prc-card, [id*="recently-viewed-products"] a.prc-card', function (e) {
                    const link = e.target.closest('a.prc-card, a') || this;
                    const title = link.querySelector ? link.querySelector('.product-title, .prc-ttl') : '';
                    const productName = (title && title.textContent.trim())
                        || link.getAttribute ? link.getAttribute('aria-label') : ''
                        || (link.textContent || '').trim();
                    if (productName) {
                        convertGoal('100244699');
                        gtagTracking('SD_PDP_Event', 'PDP- Recently Viewed Interaction', productName);
                    }
                });

                // PDP- Sticky Header Interaction
                delegateEvent(document, 'mousedown', '.product_toggle', (e) => {
                    if (e.target.closest('a:not(.top_arrow)')) {
                        convertGoal('100244700');
                        gtagTracking('SD_PDP_Event', 'PDP- Sticky Header Interaction', e.target.closest('a:not(.top_arrow)').textContent.trim());
                    } else if (e.target.closest('a.top_arrow')) {
                        convertGoal('100244700');
                        gtagTracking('SD_PDP_Event', 'PDP- Sticky Header Interaction', 'Move to top arrow');
                    }
                });

                // Mini Cart Open, Mini Cart Close
                waitUntil(() => document.querySelector('shadow-dom-container'), () => {
                    const shadowContainer = document.querySelector('shadow-dom-container');
                    const { shadowRoot } = shadowContainer;

                    const observer = new MutationObserver((mutationsList) => {
                        mutationsList.forEach((mutation) => {
                            const added = Array.from(mutation.addedNodes).filter(
                                (node) => node.nodeType === 1 && node.tagName !== 'STYLE'
                            );
                            const removed = Array.from(mutation.removedNodes).filter(
                                (node) => node.nodeType === 1 && node.tagName !== 'STYLE'
                            );

                            added.forEach((node) => {
                                if (node.classList.contains('sidecart')) {
                                    convertGoal('100244701');
                                    gtagTracking('SD_PDP_Event', 'Mini Cart Open', 'Open');
                                }
                            });

                            removed.forEach((node) => {
                                if (node.classList.contains('sidecart')) {
                                    convertGoal('100244702');
                                    gtagTracking('SD_PDP_Event', 'Mini Cart Close', 'Close');
                                }
                            });
                        });
                    });

                    observer.observe(shadowRoot, { childList: true, subtree: true });
                });

                // Survey Popup Visible
                let surveyVisible = false;
                waitUntil(() => document.querySelector('#widget-_affiniv [class^="main-root"]'), () => {
                    const surveyContainer = document.querySelector('#widget-_affiniv [class^="main-root"]');
                    if (surveyContainer && !surveyVisible) {
                        surveyVisible = true;
                        convertGoal('100245898');
                        gtagTracking('SD_PDP_Event', 'Survey Popup Visible', pathname);
                    }

                    surveyContainer.addEventListener('mousedown', ({ target }) => {
                        // Survey Popup closed
                        if (target.closest('div[style*="data:image/svg+xml;base64,PHN2ZyB4bWx"]')) {
                            convertGoal('100245899');
                            gtagTracking('SD_PDP_Event', 'Survey Popup closed', pathname);
                        }

                        // Clicks on OK
                        const okButton = target.closest('button');
                        if (okButton && okButton.textContent.toLowerCase().trim() === 'ok') {
                            const productName = okButton.closest('body').querySelector('#main #product .product-title');
                            if (productName) {
                                convertGoal('100245900');
                                gtagTracking('SD_PDP_Event', 'Clicks on OK', productName.textContent.trim());
                            }
                        }
                    });

                    // Interaction with Text Box
                    const textArea = surveyContainer.querySelector('textarea');
                    if (textArea) {
                        textArea.addEventListener('input', debounce(({ target }) => {
                            convertGoal('100245901');
                            gtagTracking('SD_PDP_Event', 'Interaction with Text Box', target.value);
                        }, 800));
                    }
                });
            }

            // Cart
            // Mini Cart Open
            delegateEvent(document, 'mousedown', 'nav a[href*="/cart"]', () => {
                convertGoal('100244701');
                gtagTracking('SD_Cart_Event', 'Mini Cart Open', 'Interaction');
            });

            waitUntil(
                () => document.querySelector('shadow-dom-container') !== null,
                () => {
                    // Mini Cart Close
                    delegateEvent(document.querySelector('shadow-dom-container').shadowRoot, 'mousedown', '.sidecart:not(.offer-popup) .side-cart-header .close-btn', () => {
                        convertGoal('100244702');
                        gtagTracking('SD_Cart_Event', 'Mini Cart Close', 'Interaction');
                    });

                    // Mini Cart- View All Offers
                    delegateEvent(document.querySelector('shadow-dom-container').shadowRoot, 'mousedown', '.sidecart .offer-box button.view-offers-button', () => {
                        convertGoal('100244703');
                        gtagTracking('SD_Cart_Event', 'Mini Cart- View All Offers', 'Interaction');
                    });

                    // Mini Cart- Apply Offers
                    delegateEvent(
                        document.querySelector('shadow-dom-container').shadowRoot,
                        'mousedown',
                        '.sidecart .offer-box .featured-offer .apply-btn:not(.remove-btn)',
                        function () {
                            const offerEl = this.closest('.featured-offer');
                            if (offerEl) {
                                const titleEl = offerEl.querySelector('.offer-details .offer-title');
                                if (titleEl) {
                                    const offerTitle = titleEl.textContent.trim();
                                    convertGoal('100244704');
                                    gtagTracking('SD_Cart_Event', 'Mini Cart- Apply Offers', offerTitle);
                                }
                            }
                        }
                    );

                    delegateEvent(
                        document.querySelector('shadow-dom-container').shadowRoot,
                        'mousedown',
                        '.sidecart .offer-popup .available .apply-btn',
                        function () {
                            const wrapper = this.closest('.offer-wrapper');
                            if (wrapper) {
                                const titleEl = wrapper.querySelector('.offer-title');
                                if (titleEl) {
                                    const offerTitle = titleEl.textContent.trim();
                                    convertGoal('100244704');
                                    gtagTracking('SD_Cart_Event', 'Mini Cart- Apply Offers', offerTitle);
                                }
                            }
                        }
                    );

                    // Mini Cart- Remove Product
                    delegateEvent(document.querySelector('shadow-dom-container').shadowRoot, 'mousedown', '.sidecart .item-list-wrapper .item .remove-btn', () => {
                        convertGoal('100244705');
                        gtagTracking('SD_Cart_Event', 'Mini Cart- Remove Product', 'Interaction');
                    });

                    // Mini Cart- Interaction with Qty
                    delegateEvent(document.querySelector('shadow-dom-container').shadowRoot, 'mousedown', '.sidecart .item-list-wrapper .item .quantity-handler', () => {
                        convertGoal('100244706');
                        gtagTracking('SD_Cart_Event', 'Mini Cart- Interaction with Qty', 'Interaction');
                    });

                    // Mini Cart- Complete Your Look ATC
                    delegateEvent(
                        document.querySelector('shadow-dom-container').shadowRoot,
                        'mousedown',
                        '.sidecart .top-close-button .sheet-wrapper .variant-list .item button.add-to-cart',
                        function () {
                            const item = this.closest('.item');
                            if (item) {
                                const titleEl = item.querySelector('.sidecart-product-title');
                                if (titleEl) {
                                    const productName = titleEl.textContent.trim();
                                    convertGoal('100244707');
                                    gtagTracking('SD_Cart_Event', 'Mini Cart- Complete Your Look ATC', productName);
                                }
                            }
                        }
                    );

                    // Mini Cart- Place Order CTA
                    delegateEvent(
                        document.querySelector('shadow-dom-container').shadowRoot,
                        'mousedown',
                        '.sidecart .sidecart-footer .gokwik-checkout  button[type="button"]',
                        function () {
                            convertGoal('100244708');
                            gtagTracking('SD_Cart_Event', 'Mini Cart- Place Order CTA', pathname);
                            const sideCart = this.closest('.sidecart ');
                            if (sideCart) {
                                const items = sideCart.querySelectorAll('.item-list-wrapper .item');
                                if (items.length > 0) {
                                    gtagTracking('SD_29 ', 'Mini Cart- Place Order CTA', items.length);
                                }
                            }
                        }
                    );
                }
            );
        });
    }, 2000);
}());


//Sitewide

/* eslint-disable max-len */
/* eslint-disable func-names */
/* eslint-disable*/
(function trackingSitewide() {
    function gtagTracking(event_category, event_action, event_label) {
        window.gtag('event', 'Convert_Test_Tracking', {
            method: 'Convert',
            event_category,
            event_action,
            event_label
        });
    }

    function waitUntil(predicate, success, error) {
        let int = setInterval(() => {
            if (predicate()) {
                clearInterval(int);
                int = null;
                success();
            }
        }, 50);
        setTimeout(() => {
            if (int !== null) {
                clearInterval(int);
                if (typeof error === 'function') {
                    error();
                }
            }
        }, 20000);
    }

    function insertQueryParam(sel, param) {
        const links = document.querySelectorAll(sel);
        links.forEach((link) => {
            let url = link.getAttribute('href');
            if (url.includes(param)) return;
            if (!url.includes('?')) {
                url += '?';
            } else {
                url += '&';
            }

            url += param;
            link.setAttribute('href', url);
        });
    }

    function debounce(fn, delay) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => fn.apply(this, args), delay);
        };
    }

    function delegateEvent(el, evt, sel, handler) {
        el.addEventListener(evt, function (event) {
            let t = event.target;
            while (t && t !== this) {
                if (t.matches(sel)) {
                    event.matchedSelector = t;
                    handler.call(t, event);
                    break;
                }
                t = t.parentNode;
            }
        });
    }

    function convertGoal(id) {
        console.log(id);
        // window._conv_q = window._conv_q || [];
        // _conv_q.push(['triggerConversion', id]);
    }

    setTimeout(() => {
        waitUntil(() => typeof window.gtag === 'function', () => {
            const { location: { pathname, href }, innerWidth } = window;
            // Sitewide - Interaction with Hamburger Menu // Sitewide - Close Hamburger Menu //

            delegateEvent(document, 'mousedown', '.header .header__primary-nav button[aria-controls="sidebar-menu"]', () => {
                window.SD_SidebarMenuTrigger = 'header';
            });

            waitUntil(() => document.querySelector('#sidebar-menu[template="header-sidebar-template"]'), () => {
                const sidebar = document.querySelector('#sidebar-menu[template="header-sidebar-template"]');

                if (!sidebar) {
                    console.warn('Sidebar element not found!');
                    return;
                }

                const observer = new MutationObserver((mutationsList) => {
                    mutationsList.forEach((mutation) => {
                        if (mutation.type === 'attributes') {
                            const isOpen = sidebar.hasAttribute('open');

                            let { SD_SidebarMenuTrigger } = window;
                            if (isOpen) {
                                if (SD_SidebarMenuTrigger === 'header') {
                                    convertGoal('100244411');
                                    gtagTracking('SD_SI_Event', 'Sitewide- Interaction with Hamburger Menu', `${pathname} - Open`);
                                } else if (SD_SidebarMenuTrigger === 'footer') {
                                    convertGoal('100245700');
                                    gtagTracking('SD_SI_Event', 'Footer- Interaction with Hamburger Menu', pathname);
                                }
                            } else if (SD_SidebarMenuTrigger === 'header') {
                                convertGoal('100244412');
                                gtagTracking('SD_SI_Event', 'Close Hamburger Menu', `${pathname} - Close`);
                            } else if (SD_SidebarMenuTrigger === 'footer') {
                                convertGoal('100245701');
                                gtagTracking('SD_SI_Event', 'Footer- Close Hamburger Menu', pathname);
                            }

                            SD_SidebarMenuTrigger = null;
                        }
                    });
                });

                observer.observe(sidebar, {
                    attributes: true,
                    attributeFilter: ['open']
                });
            });

            if (innerWidth < 768) {
                // Sitewide- First Level Nav Interaction (mobile)
                delegateEvent(document, 'mousedown', '#sidebar-menu .header-sidebar__group-list .saadaa-accordion-title, #sidebar-menu .saadaa-accordion-title', function () {
                    const { SD_SidebarMenuTrigger } = window;
                    if (SD_SidebarMenuTrigger === 'header') {
                        convertGoal('100244438');
                        gtagTracking('SD_SI_Event', 'Sitewide- First Level Nav Interaction', this.textContent.trim());
                    } else if (SD_SidebarMenuTrigger === 'footer') {
                        convertGoal('100245723');
                        gtagTracking('SD_SI_Event', 'Footer- First Level Nav Interaction', this.textContent.trim());
                    }
                });

                // Sitewide- Sub-menu visits (mobile)
                waitUntil(() => document.querySelectorAll('#sidebar-menu .header-sidebar__group-list li a, #sidebar-menu .header-sidebar__group-list p a').length > 0, () => {
                    insertQueryParam('#sidebar-menu .header-sidebar__group-list li a, #sidebar-menu .header-sidebar__group-list p a', 'ref=sub_menu');
                });

                delegateEvent(document, 'mousedown', '#sidebar-menu .header-sidebar__group-list li a, #sidebar-menu .header-sidebar__group-list p a', function (e) {
                    if (e.target !== this && !this.contains(e.target)) return;
                    const { SD_SidebarMenuTrigger } = window;
                    const label = this.textContent.trim();
                    if (!label) return;
                    if (SD_SidebarMenuTrigger === 'header') {
                        gtagTracking('SD_SI_Event', 'Sitewide- Sub-menu visits', label);
                    } else if (SD_SidebarMenuTrigger === 'footer') {
                        gtagTracking('SD_SI_Event', 'Footer- Sub-menu visits', label);
                    }
                });
            } else {
                // Sitewide- First Level Nav Interaction //
                delegateEvent(document, 'mousedown', '#sidebar-menu .header-sidebar__group-list .saadaa-accordion-title', function () {
                    const { SD_SidebarMenuTrigger } = window;
                    if (SD_SidebarMenuTrigger === 'header') {
                        convertGoal('100244438');
                        gtagTracking('SD_SI_Event', 'Sitewide- First Level Nav Interaction', this.textContent.trim());
                    } else if (SD_SidebarMenuTrigger === 'footer') {
                        convertGoal('100245723');
                        gtagTracking('SD_SI_Event', 'Footer- First Level Nav Interaction', this.textContent.trim());
                    }
                });

                // Sitewide- Sub-menu visits //
                waitUntil(() => document.querySelectorAll('#sidebar-menu .header-sidebar__group-list li a, #sidebar-menu .header-sidebar__group-list p a').length > 0, () => {
                    insertQueryParam('#sidebar-menu .header-sidebar__group-list li a, #sidebar-menu .header-sidebar__group-list p a', 'ref=sub_menu');
                });

                delegateEvent(document, 'mousedown', '#sidebar-menu .header-sidebar__group-list li a, #sidebar-menu .header-sidebar__group-list p a', function (e) {
                    if (e.target !== this) return;
                    const { SD_SidebarMenuTrigger } = window;
                    if (SD_SidebarMenuTrigger === 'header') {
                        gtagTracking('SD_SI_Event', 'Sitewide- Sub-menu visits', this.textContent.trim());
                    } else if (SD_SidebarMenuTrigger === 'footer') {
                        gtagTracking('SD_SI_Event', 'Footer- Sub-menu visits', this.textContent.trim());
                    }
                });
            }

            // Sitewide- Search Interaction //
            delegateEvent(document, 'input', '.header .header-search', debounce((event) => {
                const inputWord = event.target.value;
                if (inputWord.length > 1) {
                    convertGoal('100244413');
                    gtagTracking('SD_SI_Event', 'Sitewide- Search Interaction', inputWord);
                }
            }, 600));

            // SRP Visits
            if (href.includes('/search?q=')) {
                convertGoal('100245031');
                gtagTracking('SD_SI_Event', 'SRP Visits', href);
            }

            // Sitewide- Interaction with Whatsapp icon //
            delegateEvent(document, 'mousedown', '.floating-whatsapp1', () => {
                convertGoal('100244414');
                gtagTracking('SD_SI_Event', 'Sitewide- Interaction with Whatsapp icon', 'Interaction');
            });

            // Sitewide- Interaction with Cart Icon, Close Cart
            waitUntil(() => document.querySelector('shadow-dom-container'), () => {
                const shadowContainer = document.querySelector('shadow-dom-container');
                const { shadowRoot } = shadowContainer;

                const observer = new MutationObserver((mutationsList) => {
                    mutationsList.forEach((mutation) => {
                        const added = Array.from(mutation.addedNodes).filter(
                            (node) => node.nodeType === 1 && node.tagName !== 'STYLE'
                        );
                        const removed = Array.from(mutation.removedNodes).filter(
                            (node) => node.nodeType === 1 && node.tagName !== 'STYLE'
                        );

                        added.forEach((node) => {
                            if (node.classList.contains('sidecart')) {
                                convertGoal('100244415');
                                gtagTracking('SD_SI_Event', 'Sitewide- Interaction with Cart Icon', 'Open');
                            }
                        });

                        removed.forEach((node) => {
                            if (node.classList.contains('sidecart')) {
                                convertGoal('100244492');
                                gtagTracking('SD_SI_Event', 'Close Cart', 'Close');
                            }
                        });
                    });
                });

                observer.observe(shadowRoot, { childList: true, subtree: true });
            });

            // Gullak on desktop
            delegateEvent(document, 'mousedown', '#nector-rewards-widget-container, [id^="nector-rewards-widget"], .nector-websdk-widget', () => {
                convertGoal('100245665');
                gtagTracking('SD_SI_Event', 'Sitewide - Clicks on Gullak', pathname);
            });

            /* Footer */
            delegateEvent(document, 'mousedown', '.fixed_nav--link[data-nav="menu"], #mobile-bottom-menu-trigger', () => {
                window.SD_SidebarMenuTrigger = 'footer';
            });

            delegateEvent(document, 'mousedown', '.fixed_nav.fixed_nav_mobile', ({ target }) => {
                const footerLink = target.closest('.fixed_nav--link');
                if (footerLink) {
                    const footerLinkName = footerLink.dataset.nav;
                    if (footerLinkName === 'home') {
                        convertGoal('100245661');
                        gtagTracking('SD_SI_Event', 'Footer - Clicks on Home', pathname);
                    } else if (footerLinkName === 'menu') {
                        window.SD_SidebarMenuTrigger = 'footer';
                    } else if (footerLinkName === 'gullak' || footerLinkName === 'discount') {
                        convertGoal('100245662');
                        gtagTracking('SD_SI_Event', 'Footer - Clicks on Gullak', pathname);
                    // } else if (footerLinkName === 'community') {
                    //     convertGoal('100245663');
                    //     gtagTracking('SD_SI_Event', 'Footer - Clicks on Returns', pathname);
                    } else if (footerLinkName === 'account') {
                        convertGoal('100245664');
                        gtagTracking('SD_SI_Event', 'Footer - Clicks on Login', pathname);
                    }
                }
            });
        });
    }, 2000);
}());


//Rewards

/* eslint-disable*/
(function trackingRewards() {
    function gtagTracking(event_category, event_action, event_label) {
        window.gtag('event', 'Convert_Test_Tracking', {
            method: 'Convert',
            event_category,
            event_action,
            event_label
        });
    }

    function waitUntil(predicate, success, error) {
        let int = setInterval(() => {
            if (predicate()) {
                clearInterval(int);
                int = null;
                success();
            }
        }, 50);
        setTimeout(() => {
            if (int !== null) {
                clearInterval(int);
                if (typeof error === 'function') {
                    error();
                }
            }
        }, 20000);
    }

    function delegateEvent(el, evt, sel, handler) {
        el.addEventListener(evt, function (event) {
            let t = event.target;
            while (t && t !== this) {
                if (t.matches(sel)) {
                    event.matchedSelector = t;
                    handler.call(t, event);
                    break;
                }
                t = t.parentNode;
            }
        });
    }

    function convertGoal(id) {
        console.log(id);
        // window._conv_q = window._conv_q || [];
        // _conv_q.push(['triggerConversion', id]);
    }

    setTimeout(() => {
        waitUntil(() => typeof window.gtag === 'function', () => {
            const { location: { pathname } } = window;

            // Rewards
            if (pathname.includes('/pages/rewards')) {
                waitUntil(() => document.querySelector('#nector-reward-page-container') && document.querySelector('#nector-reward-page-container').shadowRoot, () => {
                    const { shadowRoot } = document.querySelector('#nector-reward-page-container');
                    if (!shadowRoot) return;

                    delegateEvent(shadowRoot, 'mousedown', '#nector-render-root', ({ target }) => {
                        // Banner- Sign Up & Get Free Coins
                        if (target.closest('.nector-banner-content-btns div[role="button"]:first-child')) {
                            convertGoal('100245679');
                            gtagTracking('SD_RW_Event', 'Banner- Sign Up & Get Free Coins', pathname);
                        }

                        // Banner- Sign In
                        if (target.closest('.nector-banner-content-btns div[role="button"]:nth-child(2)')) {
                            convertGoal('100245680');
                            gtagTracking('SD_RW_Event', 'Banner- Sign In', pathname);
                        }

                        // More Ways To Earn Rupaiya
                        const waysToEarnItems = target.closest('#waystoearn .nector-waystoearn-items .nector-waystoearn-item');
                        if (waysToEarnItems) {
                            const waysToEarnInfo = waysToEarnItems.querySelector('.nector-waystoearn-info-container .nector-text');
                            if (waysToEarnInfo) {
                                convertGoal('100245681');
                                gtagTracking('SD_RW_Event', 'More Ways To Earn Rupaiya', waysToEarnInfo.textContent.trim());
                            }
                        }

                        // Ways To Redeem
                        const waysToRedeem = target.closest('#waystoredeem .nector-waystoredeem-items .nector-waystoredeem-item');
                        if (waysToRedeem) {
                            convertGoal('100245682');
                            gtagTracking('SD_RW_Event', 'Ways To Redeem', pathname);
                        }

                        // Interaction with FAQs
                        const accordionItems = target.closest('#faq.nector-faq-container .accordion-item');
                        if (accordionItems) {
                            const accordionName = accordionItems.querySelector('.accordion-header .nector-text');
                            if (accordionName) {
                                convertGoal('100245683');
                                gtagTracking('SD_RW_Event', 'Interaction with FAQs', accordionName.textContent.trim());
                            }
                        }
                    });
                });
            }
        });
    }, 2000);
}());
